export default "__VITE_ASSET__CRSnXCc5__"